import React from 'react';
import classNames from 'classnames';

class GridSelectorItem extends React.Component {

  clickHandler(value, event) {
    const { input } = this.props;
    const currentValue = input.value || [];
    const valueIndex = currentValue.indexOf(value);

    if (valueIndex >= 0) {
      input.onChange(currentValue.filter((v, i) => i !== valueIndex));
    } else {
      input.onChange(currentValue.concat(value));
    }
  }

  render() {
    const selected = (this.props.input.value || []).indexOf(this.props.item.field) >= 0;

    return (
      <div className="columns small-8 medium-5" onClick={this.clickHandler.bind(this, this.props.item.field)}>
        <div className={classNames("tile", {
          "selected":selected,
          "text-only": this.props.item.icon == 'text'
          })}>
          {this.props.item.icon == 'text' ?
            <h3 dangerouslySetInnerHTML={{ __html: this.props.item.label }}/>:
            <div>
              <i className={this.props.item.icon} />
              <h4 dangerouslySetInnerHTML={{ __html: this.props.item.label }}/>
            </div>
          }
        </div>
      </div>
    );
  }
}

/**
 * Used for rendering a Grid of choices, e.g. "font style" in logo projects.
 */
class GridSelectorInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showFieldHelp: false
    }

    this.toggleHelp = this.toggleHelp.bind(this);
  }

  toggleHelp(event) {
    event.preventDefault();

    this.setState({
      showFieldHelp: !this.state.showFieldHelp
    })
  }

  render (){
    return (
      <div className="row grid-selector">
        { this.props.options.map(
          (itemData) =>
          <GridSelectorItem key={itemData.field} item={itemData} input={this.props.input} meta={this.props.meta} />)
        }
      </div>);
  }
};

export default GridSelectorInput
